import m, * as bacta from "bacta"

import "@shoelace-style/shoelace/dist/themes/light.css"
import "@shoelace-style/shoelace/dist/components/dialog/dialog.js"

export type DialogAttrs = {
	open: boolean
	name?: string
	noHeader?: boolean
} & bacta.Attributes

export const Dialog: bacta.ClosureComponent<DialogAttrs> = () => {
	return {
		view: ({ attrs, children }) => {
			return m("sl-dialog", attrs, children)
		},
	}
}
